export default {
  text: {
    en: `
    Meet our long-lasting, super-hydrating lip balms, packed with nourishing oils,
    botanical extracts + all those smell-so-good ingredients you've come to love from Scentbird.
  `,
  },
  pictureTitle: {
    en: 'Lip Balms',
  },
  buttonTitle: {
    en: 'Got it',
  },
}
